import axios from './axios';

export const getSuppliers = ({ params } = {}) => axios.get(`suppliers`, { params });
export const getSupplier = ({ id, params }) => axios.get(`suppliers/${id}`, { params });
export const createSupplier = ({ data }) => axios.post('suppliers', data);
export const updateSupplier = ({ id, data }) => axios.put(`suppliers/${id}`, data);
export const deleteSupplier = ({ id }) => axios.delete(`suppliers/${id}`);
export const toggleSupplierActive = ({ id }) => axios.patch(`suppliers/${id}/toggle-active`);
export const getSupplierStatistics = ({ id }) => axios.get(`suppliers/${id}/statistics`);
